import * as React from "react";
import { BugOff, DoorOpen, Frame, Cat } from "lucide-react";
import { Card } from "@/components/ui/card";
const problems = [{
  id: 1,
  title: "Persistent Fatigue",
  description: "Feeling drained regardless of rest? We identify underlying metabolic imbalances to restore your natural vitality and daily energy levels.",
  icon: BugOff
}, {
  id: 2,
  title: "Digestive Discomfort",
  description: "Struggling with bloating or irregularity? Our approach addresses gut health at the root, ensuring your system functions smoothly and efficiently.",
  icon: DoorOpen
}, {
  id: 3,
  title: "Cognitive Clouding",
  description: "Finding it hard to focus? We optimize neurological health to clear the fog and sharpen your mental performance throughout the day.",
  icon: Frame
}, {
  id: 4,
  title: "Restless Sleep",
  description: "Tossing and turning? We analyze hormonal and environmental factors to help you achieve the deep, restorative rest your body requires.",
  icon: Cat
}];
export default function CommonProblemsWeFix() {
  return <section data-section-id="152620" id="symptoms" className="bg-background py-24 md:py-32">
      <div className="container mx-auto px-4 max-w-4xl">
        <h2 className="text-3xl md:text-5xl font-bold text-primary text-center mb-16 font-serif tracking-tight">
          Recognizing the Signs
        </h2>
        
        <div className="flex flex-col gap-6">
          {problems.map((problem, index) => {
          const Icon = problem.icon;
          return <Card key={problem.id} data-index={index} className="flex flex-col sm:flex-row items-start sm:items-center gap-6 p-8 bg-card/40 backdrop-blur-md border-none shadow-sm hover:shadow-md hover:scale-[1.01] transition-all duration-300">
                <div className="shrink-0 text-accent bg-accent/5 p-4 rounded-full sm:bg-transparent sm:p-0 sm:rounded-none">
                  <Icon className="w-8 h-8 sm:w-10 sm:h-10" strokeWidth={2} />
                </div>
                <div className="flex flex-col gap-2">
                  <h3 className="text-xl font-semibold text-foreground font-sans">
                    {problem.title}
                  </h3>
                  <p className="text-sm text-muted-foreground font-sans leading-relaxed">
                    {problem.description}
                  </p>
                </div>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}